import { useCallback, useState } from "react";
import SessaoConfiguracao, { ConfiguracaoColunas } from "../../../../../components/BasicComponents/DisplayDados/SessaoConfiguracao"
import { ITefConfig } from "../../../../../types/api/financeiro/pesquisar-tef-configs";
import DialogCriacaoEditConfig from "./DialogCriacaoEditConfig";

export type TOpenModalTEF = {
    open: number | boolean | null,
    defaultValue: ITefConfig | null,
} | null

export default function TEFConfiguracoes() {

    const [openModal, setOpenModal] = useState<TOpenModalTEF>(null)

    //funções manipuladoras
    const handleModalAction = useCallback((action: "open" | "close", value?: ITefConfig | null) => {
        if (action === "close") setOpenModal(null)
        if (action === "open" && value) setOpenModal({ open: value.id, defaultValue: value })
        if (action === "open" && !value) setOpenModal({ open: true, defaultValue: null })
    }, [])
    //

    return (
        <>
            <SessaoConfiguracao<ITefConfig>
                titulo="Configuração TEF"
                endpoints={{
                    listar: "financeiro/configuracoes/pesquisar-tef-configs",
                    deletar: "financeiro/configuracoes/excluir-tef-config",
                }}
                colunas={colunas}
                onEditar={(tef) => {
                    handleModalAction("open", tef)
                }}
                onAdicionar={() => {
                    handleModalAction("open", null)
                }}
                queryKey="pesquisar-tef-configs"
                mensagemSucessoDeletar="Configuração TEF deletada com sucesso!"
                mensagemErroDeletar="Erro ao deletar Configuração TEF!"
                mensagemSemDados="Nenhuma Configuração TEF encontrada."
            />

            {
                openModal &&
                <DialogCriacaoEditConfig
                    open={Boolean(openModal?.open)}
                    handleClose={() => handleModalAction("close")}
                    defaultValue={openModal?.defaultValue}
                />
            }
        </>
    )
}


const colunas: ConfiguracaoColunas<ITefConfig>[] = [
    {
        campo: "nome",
        titulo: "Nome",
    },
];